export const LOGOUT_CONFIRMATION_DIALOG = "LOGOUT_CONFIRMATION_DIALOG";
export const RETURN_CREATION_DIALOG = "RETURN_CREATION_DIALOG";
export const FILTER_DIALOG = "FILTER_DIALOG";
export const REQUEST_PRODUCT_DETAILS_DIALOG = "REQUEST_PRODUCT_DETAILS_DIALOG";
export const RTO_PACKAGE_ACTIONS_DIALOG = "RTO_PACKAGE_ACTIONS_DIALOG";
